import React from 'react'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'
import { device } from '../../../../config/theme/breakpoints'

const GeneralCenter = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

const ContainerParcelService = styled(GeneralCenter)`
    justify-content: flex-start;
    border-radius: 50%;
    width: 100%;
    margin-bottom: 10px;

    @media ${device.tablet}{
        width: 50%;
    }
`
const ContainerText = styled(NavLink)`
    color: ${p => p.theme.palette.text.gray};
    font-size: 14px;
    margin: 0;
    text-decoration: none;

    :hover{
        color: ${p => p.theme.palette.primary.main};
    }
`
const ContainerIcon = styled.div`
    width: 20px;
    color: ${p => p.theme.palette.secondary.main};
    margin-right: 10px;
`

interface IOwnProps{
    icon: React.ReactElement;
    name: string;
    to: string;
}

const ItemContact: React.FunctionComponent<IOwnProps> = ({
    icon,
    name,
    to
}) => {
  return (
    <ContainerParcelService>
        <ContainerIcon>
            {icon}
        </ContainerIcon>
        <ContainerText to={to}>{name}</ContainerText>
    </ContainerParcelService>
  )
}

export default ItemContact